export const SVG_LOCK = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.15992 12.4454V10.8049C5.15992 5.36863 9.56688 0.96167 15.0032 0.96167C20.4394 0.96167 24.8464 5.36863 24.8464 10.8049V12.4454H28.1275C29.0335 12.4454 29.768 13.1799 29.768 14.086V33.7724C29.768 34.6785 29.0335 35.413 28.1275 35.413H1.87885C0.972813 35.413 0.238312 34.6785 0.238312 33.7724V14.086C0.238312 13.1799 0.972813 12.4454 1.87885 12.4454H5.15992ZM26.4869 15.7265H3.51939V32.1319H26.4869V15.7265ZM13.3626 25.1307C12.3819 24.5634 11.7221 23.5032 11.7221 22.2887C11.7221 20.4765 13.191 19.0076 15.0032 19.0076C16.8153 19.0076 18.2842 20.4765 18.2842 22.2887C18.2842 23.5032 17.6244 24.5634 16.6437 25.1307V28.8508H13.3626V25.1307ZM8.441 12.4454H21.5653V10.8049C21.5653 7.18072 18.6273 4.24275 15.0032 4.24275C11.379 4.24275 8.441 7.18072 8.441 10.8049V12.4454Z"
      fill="#1C1C1C"
    />
  </svg>
);

export const SVG_USER = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.754 36.7321H30.4729V33.451C30.4729 30.7328 28.2695 28.5294 25.5513 28.5294H15.708C12.9899 28.5294 10.7864 30.7328 10.7864 33.451V36.7321H7.50534V33.451C7.50534 28.9208 11.1778 25.2483 15.708 25.2483H25.5513C30.0814 25.2483 33.754 28.9208 33.754 33.451V36.7321ZM20.6296 21.9672C15.1934 21.9672 10.7864 17.5602 10.7864 12.124C10.7864 6.68772 15.1934 2.28076 20.6296 2.28076C26.0659 2.28076 30.4729 6.68772 30.4729 12.124C30.4729 17.5602 26.0659 21.9672 20.6296 21.9672ZM20.6296 18.6861C24.2538 18.6861 27.1918 15.7482 27.1918 12.124C27.1918 8.49981 24.2538 5.56184 20.6296 5.56184C17.0055 5.56184 14.0675 8.49981 14.0675 12.124C14.0675 15.7482 17.0055 18.6861 20.6296 18.6861Z"
      fill="currentColor"
    />
  </svg>
);

export const SVG_CHEVRON_DOWN = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.7}
    stroke="currentColor"
    className="size-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19.5 8.25-7.5 7.5-7.5-7.5"
    />
  </svg>
);

export const SVG_CHEVRON_UP = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.7}
    stroke="currentColor"
    className="size-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 15.75l7.5-7.5 7.5 7.5"
    />
  </svg>
);

export const SVG_UNLOCK = () => (
  <svg
    width="30"
    height="24"
    viewBox="0 0 30 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.43066 0.679688L16.2911 0.679859C20.9203 0.704951 19.3998 0.679757 24.836 0.679757C24.836 1.6805 23.3653 2.32022 24.836 0.679757L21.555 0.679688H28.1171C29.0232 0.679688 29.7576 1.41419 29.7576 2.32023V22.0067C29.7576 22.9127 29.0232 23.6472 28.1171 23.6472H1.8685C0.962468 23.6472 0.227966 22.9127 0.227966 22.0067V2.32023C0.227966 1.41419 0.962468 0.679688 1.8685 0.679688H8.43066ZM26.4766 3.96077H3.50904V20.3661H26.4766V3.96077ZM13.3523 13.365C12.3716 12.7977 11.7117 11.7374 11.7117 10.5229C11.7117 8.71079 13.1807 7.24184 14.9928 7.24184C16.8049 7.24184 18.2739 8.71079 18.2739 10.5229C18.2739 11.7374 17.6141 12.7977 16.6333 13.365V17.0851H13.3523V13.365ZM8.43066 0.679688H21.555L24.836 0.679757C18.2739 0.679688 25.1791 0.679688 21.555 0.679688C17.9308 0.679688 13.6731 3.34448 16.2911 0.679859L8.43066 0.679688Z"
      fill="#1C1C1C"
    />
  </svg>
);

export const SVG_COPY = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="scale-105"
  >
    <rect
      x="16.5962"
      y="14.2793"
      width="24.0381"
      height="28.0821"
      rx="1.24929"
      stroke="currentColor"
      strokeWidth="4.99715"
      strokeLinejoin="round"
    />
    <path
      d="M8.58441 34.3399C8.58441 34.3399 8.58441 13.1401 8.58441 7.50021C8.58441 6.81025 9.14374 6.25781 9.8337 6.25781H32.6225"
      stroke="currentColor"
      strokeWidth="4.99715"
      strokeLinecap="round"
    />
  </svg>
);
export const SVG_PREFERENCES = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 37 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="scale-105"
  >
    <path
      d="M30.5863 17.0392C28.3361 17.0392 26.512 15.2151 26.512 12.9649C26.512 10.7148 28.3361 8.89067 30.5863 8.89067M30.5863 17.0392C32.8364 17.0392 34.6605 15.2151 34.6605 12.9649C34.6605 10.7148 32.8364 8.89067 30.5863 8.89067M30.5863 17.0392V35.3733M30.5863 8.89067V2.7793M6.14078 17.0392C3.89063 17.0392 2.06653 15.2151 2.06653 12.9649C2.06653 10.7148 3.89063 8.89067 6.14078 8.89067M6.14078 17.0392C8.39092 17.0392 10.215 15.2151 10.215 12.9649C10.215 10.7148 8.39092 8.89067 6.14078 8.89067M6.14078 17.0392L6.14078 35.3733M6.14078 8.89067L6.14078 2.7793M18.3635 29.2619C16.1134 29.2619 14.2893 27.4378 14.2893 25.1877C14.2893 22.9375 16.1134 21.1134 18.3635 21.1134M18.3635 29.2619C20.6137 29.2619 22.4378 27.4378 22.4378 25.1877C22.4378 22.9375 20.6137 21.1134 18.3635 21.1134M18.3635 29.2619L18.3635 35.3733M18.3635 21.1134L18.3635 2.7793"
      stroke="currentColor"
      strokeWidth="4.07425"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SVG_REMOVE = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 35 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="scale-105"
  >
    <path
      d="M13.3725 19.1802L13.3725 32.3557M20.9014 19.1802V32.3557M30.3124 13.5335L28.4302 36.5906C28.4302 37.4642 28.0336 38.302 27.3276 38.9198C26.6217 39.5375 25.6642 39.8845 24.6658 39.8845H9.60808C8.60969 39.8845 7.65219 39.5375 6.94623 38.9198C6.24026 38.302 5.84365 37.4642 5.84365 36.5906L3.96144 13.5335H30.3124ZM11.4903 6.00466V4.12245C11.4903 3.08293 12.333 2.24023 13.3725 2.24023H20.9014C21.9409 2.24023 22.7836 3.08293 22.7836 4.12245V6.00466C22.7836 7.04418 21.9409 7.88688 20.9014 7.88688H13.3725C12.333 7.88688 11.4903 7.04418 11.4903 6.00466ZM2.07922 12.5924V8.82798C2.07922 8.30823 2.50057 7.88688 3.02033 7.88688H31.2535C31.7733 7.88688 32.1947 8.30823 32.1947 8.82798V12.5924C32.1947 13.1122 31.7733 13.5335 31.2535 13.5335H3.02033C2.50057 13.5335 2.07922 13.1122 2.07922 12.5924Z"
      stroke="#FF0000"
      strokeWidth="3.76443"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SVG_EYE = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
);

export const SVG_EYE_SLASH = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    />
  </svg>
);

export const SVG_UP_ARROW = () => (
  <svg
    fill="currentColor"
    width="64px"
    height="64px"
    viewBox="-24 -24 72.00 72.00"
    xmlns="http://www.w3.org/2000/svg"
    transform="matrix(1, 0, 0, 1, 0, 0)"
    stroke="currentColor"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z"></path>
    </g>
  </svg>
);
export const SVG_DASHBOARD = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 1 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    transform="rotate(0)"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.918 10.0005H7.082C6.66587 9.99708 6.26541 10.1591 5.96873 10.4509C5.67204 10.7427 5.50343 11.1404 5.5 11.5565V17.4455C5.5077 18.3117 6.21584 19.0078 7.082 19.0005H9.918C10.3341 19.004 10.7346 18.842 11.0313 18.5502C11.328 18.2584 11.4966 17.8607 11.5 17.4445V11.5565C11.4966 11.1404 11.328 10.7427 11.0313 10.4509C10.7346 10.1591 10.3341 9.99708 9.918 10.0005Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.918 4.0006H7.082C6.23326 3.97706 5.52559 4.64492 5.5 5.4936V6.5076C5.52559 7.35629 6.23326 8.02415 7.082 8.0006H9.918C10.7667 8.02415 11.4744 7.35629 11.5 6.5076V5.4936C11.4744 4.64492 10.7667 3.97706 9.918 4.0006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.082 13.0007H17.917C18.3333 13.0044 18.734 12.8425 19.0309 12.5507C19.3278 12.2588 19.4966 11.861 19.5 11.4447V5.55666C19.4966 5.14054 19.328 4.74282 19.0313 4.45101C18.7346 4.1592 18.3341 3.9972 17.918 4.00066H15.082C14.6659 3.9972 14.2654 4.1592 13.9687 4.45101C13.672 4.74282 13.5034 5.14054 13.5 5.55666V11.4447C13.5034 11.8608 13.672 12.2585 13.9687 12.5503C14.2654 12.8421 14.6659 13.0041 15.082 13.0007Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.082 19.0006H17.917C18.7661 19.0247 19.4744 18.3567 19.5 17.5076V16.4936C19.4744 15.6449 18.7667 14.9771 17.918 15.0006H15.082C14.2333 14.9771 13.5256 15.6449 13.5 16.4936V17.5066C13.525 18.3557 14.2329 19.0241 15.082 19.0006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);
export const SVG_LOGOUT = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 30 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M15 12L2 12M2 12L5.5 9M2 12L5.5 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);
export const SVG_BURGER = () => (
  <svg
    width="64px"
    height="64px"
    viewBox="-6.24 -6.24 36.48 36.48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#ffffff"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M5 12H20"
        stroke="#fffff"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
      <path
        d="M5 17H20"
        stroke="#fffff"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
      <path
        d="M5 7H20"
        stroke="#fffff"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export const SVG_HOME = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 51 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.03516 52.0654V24.0736C3.03516 23.6794 3.20111 23.3034 3.49236 23.0378L24.524 3.85352C25.0593 3.36523 25.8785 3.36523 26.4138 3.85352L47.4454 23.0378C47.7366 23.3034 47.9026 23.6769 47.9026 24.0711V52.0779C47.9026 52.8523 47.2748 53.4675 46.5005 53.4675H4.43726C3.6629 53.4675 3.03516 52.8397 3.03516 52.0654Z"
      stroke="currentcolor"
      strokeWidth="5.60843"
    />
    <path
      d="M17.0562 35.2401C17.0562 34.4657 17.684 33.838 18.4583 33.838H32.4794C33.2538 33.838 33.8815 34.4657 33.8815 35.2401V52.0654C33.8815 52.8397 33.2538 53.4675 32.4794 53.4675H18.4583C17.684 53.4675 17.0562 52.8397 17.0562 52.0654V35.2401Z"
      stroke="currentcolor"
      strokeWidth="5.60843"
    />
  </svg>
);

export const SVG_CITY_PROFILE = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 56 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6957 20.8051L27.7552 5.7456L42.8147 20.8051H42.8095V45.8974H12.6987V20.8051H12.6957ZM7.68023 25.8206L3.97573 29.5251L0.429688 25.9791L24.2096 2.1991C26.1678 0.240926 29.3426 0.240926 31.3008 2.1991L55.0807 25.9791L51.5347 29.5251L47.8279 25.8183V45.8974C47.8279 48.669 45.5811 50.9158 42.8095 50.9158H12.6987C9.92707 50.9158 7.68023 48.669 7.68023 45.8974V25.8206Z"
      fill="currentcolor"
    />
  </svg>
);

export const SVG_CHARTS = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 55 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.27162 0.985352H49.6576C52.3813 0.985352 54.5894 3.19338 54.5894 5.91712V40.4395C54.5894 43.1633 52.3813 45.3713 49.6576 45.3713H5.27162C2.54787 45.3713 0.339844 43.1633 0.339844 40.4395V5.91712C0.339844 3.19338 2.54787 0.985352 5.27162 0.985352ZM5.27193 5.9175V40.4399H49.6579V5.9175H5.27193ZM15.1345 35.5085H20.0663V20.7132H15.1345V35.5085ZM29.9306 35.5079H24.9988V10.8491H29.9306V35.5079ZM34.862 35.5077H39.7938V18.2465H34.862V35.5077Z"
      fill="currentcolor"
    />
  </svg>
);

export const SVG_INDICATORS = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 51 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.85074 0.90332H46.0816C48.6117 0.90332 50.6628 3.41019 50.6628 6.50257V45.6974C50.6628 48.7897 48.6117 51.2966 46.0816 51.2966H4.85074C2.32061 51.2966 0.269531 48.7897 0.269531 45.6974V6.50257C0.269531 3.41019 2.32061 0.90332 4.85074 0.90332ZM5.30947 28.6193V46.257H45.6241V28.6193H34.2849L28.5849 21.0193L21.2767 38.0719L11.8241 28.6193H5.30947ZM5.30947 23.58H13.9114L19.5768 29.2454L27.3866 11.0227L36.8046 23.58H45.6241V5.94241H5.30947V23.58Z"
      fill="currentcolor"
    />
  </svg>
);

export const SVG_ABOUT = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 49 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.15672 36.153V4.88556H34.1283V36.153C34.1283 36.9963 34.2735 37.8059 34.5404 38.5581H7.57102C6.23764 38.5581 5.15672 37.4813 5.15672 36.153ZM41.3712 38.5582L41.3712 38.5581H41.3538C40.0284 38.5488 38.9569 37.4756 38.9569 36.153V0.0752571H36.5426V0.0751953H0.328125V36.153C0.328125 40.138 3.57088 43.3685 7.57102 43.3685H41.3411L41.3712 43.3686C45.3713 43.3686 48.6141 40.1381 48.6141 36.153V16.9121H48.6142V12.1017H38.957V16.9121H43.7855V36.153C43.7855 37.4814 42.7046 38.5582 41.3712 38.5582ZM19.643 9.69604V19.3168H9.98581V9.69604H19.643ZM29.2999 16.9121V12.1017H22.057V16.9121H29.2999ZM29.3002 21.7225V26.5328H9.98581V21.7225H29.3002ZM29.3002 33.7475V28.9371H9.98581V33.7475H29.3002Z"
      fill="currentcolor"
    />
  </svg>
);

export const SVG_LOGIN = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.35452 35.9252C4.58993 34.1606 4.08369 31.4689 4.63708 27.9372C1.74846 25.8312 0.203125 23.5699 0.203125 21.0744C0.203125 18.5789 1.74846 16.3177 4.63708 14.2117C4.08369 10.6799 4.58993 7.98824 6.35452 6.22366C8.1191 4.45907 10.8108 3.95283 14.3425 4.50622C16.4485 1.6176 18.7098 0.0722656 21.2053 0.0722656C23.7008 0.0722656 25.9621 1.6176 28.0681 4.50622C31.5998 3.95283 34.2915 4.45907 36.0561 6.22366C37.8206 7.98824 38.3269 10.6799 37.7735 14.2117C40.6621 16.3177 42.2074 18.5789 42.2074 21.0744C42.2074 23.5699 40.6621 25.8312 37.7735 27.9372C38.3269 31.4689 37.8206 34.1606 36.0561 35.9252C34.2915 37.6898 31.5998 38.196 28.0681 37.6426C25.9621 40.5312 23.7008 42.0766 21.2053 42.0766C18.7098 42.0766 16.4485 40.5312 14.3425 37.6426C10.8108 38.196 8.1191 37.6898 6.35452 35.9252ZM14.8134 33.6723C15.5884 33.5063 16.3854 33.8364 16.8161 34.5018C18.4977 37.1 19.9972 38.2584 21.2046 38.2584C22.4119 38.2584 23.9114 37.1 25.5931 34.5018C26.0237 33.8364 26.8207 33.5063 27.5958 33.6723C30.622 34.3204 32.5015 34.0792 33.3552 33.2255C34.209 32.3717 34.4501 30.4923 33.802 27.466C33.636 26.691 33.9662 25.894 34.6316 25.4633C37.2298 23.7817 38.3882 22.2822 38.3882 21.0749C38.3882 19.8675 37.2298 18.368 34.6316 16.6864C33.9662 16.2557 33.636 15.4587 33.802 14.6837C34.4501 11.6574 34.209 9.77796 33.3552 8.92422C32.5015 8.07048 30.622 7.82929 27.5958 8.4774C26.8207 8.64338 26.0237 8.31326 25.5931 7.64786C23.9114 5.04967 22.4119 3.89126 21.2046 3.89126C19.9972 3.89126 18.4977 5.04967 16.8161 7.64786C16.3854 8.31326 15.5884 8.64338 14.8134 8.4774C11.7871 7.82929 9.90769 8.07048 9.05395 8.92422C8.20021 9.77796 7.95902 11.6574 8.60713 14.6837C8.77311 15.4587 8.44299 16.2557 7.77759 16.6864C5.17939 18.368 4.02099 19.8675 4.02099 21.0749C4.02099 22.2822 5.17939 23.7817 7.77759 25.4633C8.44299 25.894 8.77311 26.691 8.60713 27.466C7.95902 30.4923 8.20021 32.3717 9.05395 33.2255C9.90769 34.0792 11.7871 34.3204 14.8134 33.6723ZM27.4917 13.9967L19.2954 22.1931L14.9176 17.8153L12.2174 20.5154L19.2954 27.5933L30.1919 16.6968L27.4917 13.9967Z"
      fill="currentcolor"
    />
  </svg>
);
export const SVG_Circle = ({ color }) => (
  <svg
    width="10"
    height="10"
    style={{ display: "inline-block", marginRight: "5px" }}
  >
    <circle cx="5" cy="5" r="5" fill={color} />
  </svg>
);

export const SVG_DELETE = () => (
  <svg
    fill="white"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M5.755,20.283,4,8H20L18.245,20.283A2,2,0,0,1,16.265,22H7.735A2,2,0,0,1,5.755,20.283ZM21,4H16V3a1,1,0,0,0-1-1H9A1,1,0,0,0,8,3V4H3A1,1,0,0,0,3,6H21a1,1,0,0,0,0-2Z"></path>
    </g>
  </svg>
);

export const SVG_USE_TEMPLATE = () => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 100 100"
    enableBackground="new 0 0 100 100"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M73.8,20H26.2c-3.4,0-6.2,2.8-6.2,6.2v47.6c0,3.4,2.8,6.2,6.2,6.2h47.6c3.4,0,6.2-2.8,6.2-6.2V26.2 C80,22.8,77.2,20,73.8,20z M42.3,69.1c0,0.8-0.8,1.4-1.6,1.4H30.6h-0.2c-0.8,0-1.4-0.8-1.4-1.6V48.8c0-0.8,0.8-1.4,1.6-1.4H41 c0.8,0,1.4,0.8,1.4,1.6V69.1z M70.7,69.3c0,0.8-0.8,1.4-1.6,1.4H49.9c-0.8,0-1.4-0.8-1.4-1.6V48.8c0-0.8,0.8-1.4,1.6-1.4h19.1h0.2 c0.8,0,1.4,0.8,1.4,1.6V69.3z M70.9,39.9c0,0.8-0.8,1.4-1.6,1.4H30.6h-0.2c-0.8,0-1.4-0.8-1.4-1.6v-9c0-0.8,0.8-1.4,1.6-1.4h38.9 c0.8,0,1.4,0.8,1.4,1.6V39.9z"></path>
    </g>
  </svg>
);

export const SVG_COMPLETE_DRAFT = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M6 18.5V9.62132C6 9.2235 6.15803 8.84197 6.43934 8.56066L10.5607 4.43934C10.842 4.15804 11.2235 4 11.6213 4H16.5C17.3284 4 18 4.67157 18 5.5V18.5C18 19.3284 17.3284 20 16.5 20H7.5C6.67157 20 6 19.3284 6 18.5Z"
        stroke="currentColor"
        strokeWidth="2"
      ></path>
      <path
        d="M6 10H10.5C11.3284 10 12 9.32843 12 8.5V4"
        stroke="currentColor"
        strokeWidth="1.5"
      ></path>
    </g>
  </svg>
);

export const SVG_VIEW_QUESTIONNAIRE = () => (
  <svg
    version="1.1"
    id="_x32_"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="20px"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="currentColor"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <style type="text/css">.st0fill:#000000;</style>
      <g>
        <path
          className="st0"
          d="M449.891,87.953c-3.766-8.906-10.031-16.438-17.922-21.781c-7.891-5.328-17.5-8.469-27.719-8.469h-42.656 v-7.359h-61.828c0.281-2,0.438-4.063,0.438-6.141C300.203,19.828,280.375,0,256,0s-44.203,19.828-44.203,44.203 c0,2.078,0.156,4.141,0.438,6.141h-61.828v7.359H107.75c-6.797,0-13.359,1.391-19.281,3.906 c-8.922,3.766-16.453,10.031-21.797,17.922c-5.328,7.906-8.469,17.5-8.469,27.719v355.219c0,6.797,1.391,13.344,3.891,19.281 c3.781,8.906,10.047,16.438,17.938,21.781S97.531,512,107.75,512h296.5c6.797,0,13.359-1.375,19.297-3.906 c8.906-3.75,16.438-10.031,21.781-17.922c5.328-7.891,8.469-17.5,8.469-27.703V107.25 C453.797,100.438,452.406,93.891,449.891,87.953z M256,27.797c9.047,0,16.406,7.359,16.406,16.406c0,2.172-0.438,4.234-1.219,6.141 h-30.391c-0.766-1.906-1.203-3.969-1.203-6.141C239.594,35.156,246.969,27.797,256,27.797z M424.328,462.469 c0,2.813-0.563,5.406-1.578,7.797c-1.5,3.578-4.078,6.672-7.281,8.859c-3.219,2.156-7,3.406-11.219,3.406h-296.5 c-2.813,0-5.422-0.563-7.813-1.563c-3.578-1.516-6.672-4.094-8.844-7.297c-2.172-3.219-3.422-7-3.422-11.203V107.25 c0-2.813,0.563-5.422,1.578-7.813c1.516-3.594,4.063-6.672,7.281-8.844c3.219-2.156,7-3.406,11.219-3.422h42.656v6.141 c0,11.531,9.344,20.875,20.891,20.875h169.406c11.547,0,20.891-9.344,20.891-20.875v-6.141h42.656c2.813,0,5.422,0.563,7.813,1.578 c3.578,1.516,6.672,4.063,8.844,7.281c2.156,3.234,3.406,7,3.422,11.219V462.469z"
        ></path>
        <rect
          x="149.172"
          y="173.125"
          className="st0"
          width="213.641"
          height="24.547"
        ></rect>
        <rect
          x="149.172"
          y="240.656"
          className="st0"
          width="213.641"
          height="24.547"
        ></rect>
        <rect
          x="149.172"
          y="308.188"
          className="st0"
          width="213.641"
          height="24.547"
        ></rect>
        <rect
          x="256"
          y="394.125"
          className="st0"
          width="106.813"
          height="24.563"
        ></rect>
      </g>
    </g>
  </svg>
);

export const SVG_VIEW_ASSIGN_CITY = () => (
  <svg
    fill="currentColor"
    height="20px"
    width="20px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 511 511"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M511,247.5c0-0.583-0.073-1.147-0.199-1.691c-2.394-64.611-28.67-125.009-74.635-170.975C387.908,26.577,323.747,0,255.5,0 S123.092,26.577,74.834,74.834C26.577,123.092,0,187.253,0,255.5s26.577,132.408,74.834,180.666 C123.092,484.423,187.253,511,255.5,511s132.408-26.577,180.666-74.834C484.423,387.908,511,323.747,511,255.5 c0-2.293-0.035-4.58-0.095-6.863C510.961,248.265,511,247.887,511,247.5z M85.441,85.441C130.865,40.016,191.26,15,255.5,15 s124.635,25.016,170.059,70.441c41.751,41.751,66.244,96.152,69.935,154.559H471v-0.5c0-4.142-3.358-7.5-7.5-7.5H439v-16.5 c0-4.142-3.358-7.5-7.5-7.5H415v-16.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5V208h-0.5c-4.142,0-7.5,3.358-7.5,7.5v0.5h-9 v-80.5c0-4.142-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.358-7.5,7.5V208h-9v-16.5c0-4.142-3.358-7.5-7.5-7.5H295v-48.5 c0-2.634-1.382-5.076-3.641-6.431l-40-24c-2.318-1.39-5.203-1.426-7.554-0.095S240,108.798,240,111.5V152h-17V95.651 c0-0.008,0-0.016,0-0.024V63.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v26.922l-35.286,14.114 c-2.847,1.139-4.714,3.896-4.714,6.963V192h-17v-16.5c0-4.142-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.358-7.5,7.5v26.922l-17,6.8 V191.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v23.722l-3.286,1.314C65.867,217.675,64,220.433,64,223.5v8.5H39.5 c-4.142,0-7.5,3.358-7.5,7.5v8.5H15.128C16.997,186.571,41.789,129.093,85.441,85.441z M496,255.5 c0,10.965-0.746,21.814-2.181,32.5H471v-33h24.994C495.994,255.167,496,255.333,496,255.5z M439,288v-41h17v41H439z M383,288v-57h9 v57H383z M327,288v-24.5V223h9v65H327z M279,288v-10.146l33-5.5V288H279z M255.5,448c-4.142,0-7.5,3.358-7.5,7.5v40.373 c-30.169-0.918-59.381-7.37-86.474-18.868L255.5,310.742l93.974,166.262c-27.093,11.498-56.305,17.95-86.474,18.868V455.5 C263,451.358,259.642,448,255.5,448z M183,288V116.578l25-10V288H183z M151,288v-32.5V207h17v81H151z M103,288v-25h33v25H103z M79,288v-59.422l25-10V248h-8.5c-4.142,0-7.5,3.358-7.5,7.5V288H79z M47,288v-41h17v41H47z M17.181,288 c-1.107-8.243-1.798-16.583-2.054-25H32v25H17.181z M136,248h-17v-40.349c0-0.008,0-0.016,0-0.024V183h17V248z M223,167h17v121h-17 V167z M255.637,288c-0.004,0-0.008,0-0.011,0h-0.251c-0.004,0-0.008,0-0.011,0H255V124.747l25,15V262.48l-9.733,1.622 c-3.617,0.603-6.267,3.731-6.267,7.398V288H255.637z M312,257.146l-17,2.833V199h17V257.146z M351,143h17v145h-17V143z M407,223h17 v65h-17V223z M19.664,303H175.5h40h27.146L147.86,470.698c-22.799-11.431-43.859-26.58-62.419-45.139 C51.425,391.544,28.856,349.133,19.664,303z M425.559,425.559c-18.559,18.56-39.62,33.708-62.419,45.139L268.354,303H343.5h32h24 h32h59.836C482.144,349.133,459.575,391.544,425.559,425.559z"></path>
        <path d="M263,407.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v24c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V407.5z"></path>
        <path d="M255.5,391c4.142,0,7.5-3.358,7.5-7.5v-8c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v8 C248,387.642,251.358,391,255.5,391z"></path>
        <path d="M255.5,359c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3c0-1.97-0.8-3.91-2.2-5.3c-1.39-1.4-3.32-2.2-5.3-2.2 s-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3c0,1.97,0.8,3.91,2.2,5.3C251.59,358.2,253.53,359,255.5,359z"></path>
      </g>
    </g>
  </svg>
);

export const SVG_DATA_UPLOAD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 364.92"
  >
    <path
      fillRule="nonzero"
      d="M359.34 124.66c-13.56 6.7-25.71 15.36-37.41 24.9l-20.13-23.03c14.81-13.74 32.08-24.49 50.64-32.39-37.56-66.54-128.4-83.94-188.3-37.42-21.75 16.84-38.26 42.04-44.61 75.42l-2 10.43-10.4 1.84c-10.19 1.78-19.29 4.24-27.27 7.36-49.8 19.27-63.78 74.7-33.31 116.79 13.04 17.91 29.66 36.17 51.47 39.21h30.49c-.21 3-.32 6.02-.32 9.07 0 7.34.62 14.53 1.82 21.53H97.53l-1.92-.17c-30.53-3.88-55.62-26.61-73.75-51.72C-20.41 228.28.4 149.83 68.93 123.25c7.15-2.79 14.8-5.12 22.86-6.99 9.15-36.34 28.65-64.32 53.72-83.74C222.7-27.29 338.58-1.8 382.79 86.08c6.65-1.05 13.31-1.58 19.92-1.5 98.9.73 138.01 127.2 86.69 195.33-20.57 27.29-52.12 50.51-84.61 58.05l-3.41.41h-19.81a128.362 128.362 0 0 0 1.5-30.6h16.61c24.15-5.81 49.91-25.68 65.23-46.16 36.46-48.56 10.58-146.05-62.41-146.51-14.26-.12-29.11 3.33-43.16 9.56zM234.73 364.92h42.56c9.95 0 18.11-8.16 18.11-18.11v-58.64h31.04c6.54-.28 11.18-2.44 13.87-6.52 7.27-10.91-2.66-21.68-9.55-29.27-19.55-21.46-53.22-53.23-62.87-64.59-7.32-8.08-17.72-8.08-25.04 0-9.97 11.64-44.84 45.77-63.43 66.64-6.45 7.27-14.42 17.17-7.72 27.22 2.76 4.08 7.35 6.24 13.89 6.52h31.04v58.64c0 9.84 8.15 18.11 18.1 18.11z"
    />
  </svg>
);

export const SVG_NDF = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="icon line-color"
  >
    <line
      x1="17"
      y1="7"
      x2="13.16"
      y2="12.37"
      fill="none"
      stroke="rgb(44, 169, 188)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M10,14a2,2,0,0,1,4,0"
      fill="none"
      stroke="rgb(44, 169, 188)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M20,17H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1V16A1,1,0,0,1,20,17Zm-7,0H11l-1,4h4ZM8,21h8"
      fill="none"
      stroke="#e2e2e2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SVG_PUBLISH = () => (
  <svg
    fill="currentColor"
    height="30px"
    width="20px"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <title>publish-document</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="icon"
          fill="currentColor"
          transform="translate(42.666667, 33.830111)"
        >
          <path
            d="M170.666667,51.5032227 L256,136.836556 L256,392.836556 L-2.13162821e-14,392.836556 L-2.13162821e-14,51.5032227 L170.666667,51.5032227 Z M152.993555,94.1698893 L42.6666667,94.1698893 L42.6666667,350.169889 L213.333333,350.169889 L213.333333,154.509668 L152.993555,94.1698893 Z M341.333333,7.10542736e-15 L431.084945,89.7516113 L400.915055,119.921501 L362.666,81.683 L362.666667,222.169889 C362.666667,267.870058 326.742006,305.179572 281.592327,307.398789 L277.333333,307.503223 L277.333333,264.836556 C299.826385,264.836556 318.254189,247.431163 319.882971,225.354153 L320,222.169889 L319.999,81.684 L281.751611,119.921501 L251.581722,89.7516113 L341.333333,7.10542736e-15 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const SVG_CITY_LIST = () => (
  <svg
    fill="currentColor"
    height="30px" /* Increased size */
    width="20px" /* Increased size */
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
  >
    <path
      d="M81.8,1.3v13.1c0,0,0,0.1,0,0.1v9.3v231.5h22.6h18.2h29.6h2.5V224h17.2v31.2h2.5h29.6h18.2h22.6V23.8v-9.3h0V1.3H81.8z 
         M122.5,246.3h-18.2V224h18.2V246.3z M122.5,206.2h-18.2V184h18.2V206.2z M122.5,166.1h-18.2v-22.3h18.2V166.1z M122.5,128.2h-18.2 
         V106h18.2V128.2z M122.5,89.1h-18.2V66.9h18.2V89.1z M122.5,50h-18.2V27.7h18.2V50z M171.8,206.3h-17.2V184h17.2V206.3z M171.8,166.2
         h-17.2v-22.3h17.2V166.2z M171.8,128.3h-17.2V106h17.2V128.3z M171.8,89.2h-17.2V66.9h17.2V89.2z M171.8,50.1h-17.2 
         V27.7h17.2V50.1z M221.7,106c0.2,0,0.3,0.1,0.4,0.2v22c-0.1,0-0.2,0.2-0.4,0.2h-17.8V106H221.7z M203.9,89.3V66.9h17.8 
         c0.2,0,0.3,0.1,0.4,0.2v22c-0.1,0-0.2,0.2-0.4,0.2H203.9z M221.7,143.9c0.2,0,0.3,0.1,0.4,0.2v22.1c-0.1,0-0.2,0.2-0.4,0.2h-17.8 
         v-22.4H221.7z M221.7,184c0.2,0,0.3,0.1,0.4,0.2v22.1c-0.1,0-0.2,0.2-0.4,0.2h-17.8V184H221.7z M222.1,50c-0.1,0-0.2,0.2-0.4,0.2 
         h-17.8V27.7h17.8c0.2,0,0.3,0.1,0.4,0.2V50z M221.7,246.5h-17.8V224h17.8c0.2,0,0.3,0.1,0.4,0.2v22.1 
         C221.9,246.3,221.8,246.5,221.7,246.5z M13,84.7v170.5h57.8V84.7H13z M50.6,106v22.3H33.2V106H50.6z M50.6,166.1H33.2v-22.3h17.4 
         V166.1z M33.2,184h17.4v22.3H33.2V184z M33.2,246.4v-22.3h17.4v22.3H33.2z"
    />
  </svg>
);
export const SVG_DATA_SUBMISSION = () => (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g opacity="0.9">
        <path
          d="M9 17V11L7 13"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M9 11L11 13"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
      <path
        d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const SVG_IMIS_CITY = () => (
  <svg
    fill="currentcolor"
    width="30"
    height="30"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M15 5 A 1.0001 1.0001 0 0 0 14 6L14 25L7 25 A 1.0001 1.0001 0 0 0 6 26L6 29.716797L0.048828125 43.605469 A 1.0001 1.0001 0 0 0 0.96679688 45L49.140625 45 A 1.0001 1.0001 0 0 0 50.046875 43.576172L44 30.621094L44 22 A 1.0001 1.0001 0 0 0 43 21L37 21L37 14 A 1.0001 1.0001 0 0 0 36 13L29 13L29 6 A 1.0001 1.0001 0 0 0 28 5L15 5 z M 16 7L27 7L27 13L23 13 A 1.0001 1.0001 0 0 0 22 14L22 25L16 25L16 7 z M 18 9L18 11L20 11L20 9L18 9 z M 23 9L23 11L25 11L25 9L23 9 z M 18 13L18 15L20 15L20 13L18 13 z M 24 15L35 15L35 21L31 21 A 1.0001 1.0001 0 0 0 30 22L30 39L24 39L24 26L24 15 z M 18 17L18 19L20 19L20 17L18 17 z M 26 17L26 19L28 19L28 17L26 17 z M 31 17L31 19L33 19L33 17L31 17 z M 18 21L18 23L20 23L20 21L18 21 z M 26 21L26 23L28 23L28 21L26 21 z M 32 23L42 23L42 39L34 39L32 39L32 23 z M 26 25L26 27L28 27L28 25L26 25 z M 34 25L34 27L36 27L36 25L34 25 z M 38 25L38 27L40 27L40 25L38 25 z M 8 27L22 27L22 39L8 39L8 27 z M 10 29L10 31L12 31L12 29L10 29 z M 14 29L14 31L16 31L16 29L14 29 z M 18 29L18 31L20 31L20 29L18 29 z M 26 29L26 31L28 31L28 29L26 29 z M 34 29L34 31L36 31L36 29L34 29 z M 38 29L38 31L40 31L40 29L38 29 z M 10 33L10 35L12 35L12 33L10 33 z M 14 33L14 35L16 35L16 33L14 33 z M 18 33L18 35L20 35L20 33L18 33 z M 26 33L26 35L28 35L28 33L26 33 z M 34 33L34 35L36 35L36 33L34 33 z M 38 33L38 35L40 35L40 33L38 33 z M 6 34.796875L6 40 A 1.0001 1.0001 0 0 0 7 41L23 41L34 41L43 41 A 1.0001 1.0001 0 0 0 44 40L44 35.349609L47.570312 43L2.484375 43L6 34.796875 z"></path>
    </g>
  </svg>
);

export const SVG_EDIT_ICON = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.3628 15.2807C23.3628 14.7284 22.9151 14.2807 22.3628 14.2807C21.8105 14.2807 21.3628 14.7284 21.3628 15.2807H23.3628ZM22.3628 25.8315V26.8315C22.9151 26.8315 23.3628 26.3838 23.3628 25.8315H22.3628ZM1.26123 25.8315H0.26123C0.26123 26.3838 0.708946 26.8315 1.26123 26.8315L1.26123 25.8315ZM1.26123 2.09224V1.09224C0.708946 1.09224 0.26123 1.53995 0.26123 2.09224H1.26123ZM14.4497 3.09224C15.002 3.09224 15.4497 2.64452 15.4497 2.09224C15.4497 1.53995 15.002 1.09224 14.4497 1.09224V3.09224ZM10.0591 13.4948L11.0396 13.6909L10.0591 13.4948ZM10.5399 12.5962L11.2471 13.3034L10.5399 12.5962ZM9.43298 17.8667L9.23686 16.8861L9.43298 17.8667ZM9.22606 17.6598L8.24548 17.4636L9.22606 17.6598ZM14.4965 16.5528L13.7894 15.8457L14.4965 16.5528ZM13.5979 17.0337L13.794 18.0143L13.5979 17.0337ZM24.7462 3.81622L25.4533 3.10912V3.10912L24.7462 3.81622ZM24.7462 6.30306L25.4533 7.01017L24.7462 6.30306ZM23.2765 2.34652L22.5694 3.05363L22.5694 3.05363L23.2765 2.34652ZM20.7897 2.34652L20.0825 1.63942L20.7897 2.34652ZM21.3628 15.2807V25.8315H23.3628V15.2807H21.3628ZM22.3628 24.8315H1.26123V26.8315H22.3628V24.8315ZM1.26123 3.09224H14.4497V1.09224H1.26123V3.09224ZM0.26123 2.09224V25.8315H2.26123V2.09224H0.26123ZM22.5694 3.05363L24.0391 4.52333L25.4533 3.10912L23.9836 1.63942L22.5694 3.05363ZM24.0391 5.59596L13.7894 15.8457L15.2036 17.2599L25.4533 7.01017L24.0391 5.59596ZM13.4018 16.0531L9.23686 16.8861L9.6291 18.8472L13.794 18.0143L13.4018 16.0531ZM10.2066 17.8559L11.0396 13.6909L9.07847 13.2987L8.24548 17.4636L10.2066 17.8559ZM11.2471 13.3034L21.4968 3.05363L20.0825 1.63942L9.83284 11.8891L11.2471 13.3034ZM11.0396 13.6909C11.069 13.5441 11.1412 13.4092 11.2471 13.3034L9.83284 11.8891C9.44775 12.2742 9.18527 12.7647 9.07847 13.2987L11.0396 13.6909ZM9.23686 16.8861C9.81353 16.7708 10.322 17.2792 10.2066 17.8559L8.24548 17.4636C8.08093 18.2864 8.80634 19.0118 9.6291 18.8472L9.23686 16.8861ZM13.7894 15.8457C13.6835 15.9516 13.5486 16.0237 13.4018 16.0531L13.794 18.0143C14.3281 17.9075 14.8185 17.645 15.2036 17.2599L13.7894 15.8457ZM24.0391 4.52333C24.3353 4.81953 24.3353 5.29976 24.0391 5.59596L25.4533 7.01017C26.5305 5.93292 26.5305 4.18636 25.4533 3.10912L24.0391 4.52333ZM23.9836 1.63942C22.9064 0.562168 21.1598 0.562172 20.0825 1.63942L21.4968 3.05363C21.793 2.75743 22.2732 2.75743 22.5694 3.05363L23.9836 1.63942ZM18.3586 4.77761L22.3151 8.73415L23.7293 7.31994L19.7728 3.3634L18.3586 4.77761Z"
      fill="currentColor"
    />
  </svg>
);

export const SVG_VIDEO_PLAYER = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2625 28.3143C22.6263 28.3143 28.5959 22.3447 28.5959 14.9809C28.5959 7.61715 22.6263 1.64761 15.2625 1.64761C7.89874 1.64761 1.9292 7.61715 1.9292 14.9809C1.9292 22.3447 7.89874 28.3143 15.2625 28.3143Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8653 14.4093C22.2969 14.6682 22.2969 15.2937 21.8653 15.5526L12.1611 21.3751C11.7167 21.6418 11.1514 21.3217 11.1514 20.8035V9.15841C11.1514 8.64021 11.7167 8.32014 12.1611 8.58675L21.8653 14.4093Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
);

export const SVG_MONITOR_ICON = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.69971 22.481H17.6997M13.1997 17.981V22.481M3.59971 1.48096H22.7997C24.1252 1.48096 25.1997 2.53629 25.1997 3.8381V15.6238C25.1997 16.9256 24.1252 17.981 22.7997 17.981H3.59971C2.27422 17.981 1.19971 16.9256 1.19971 15.6238V3.8381C1.19971 2.53629 2.27422 1.48096 3.59971 1.48096Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SVG_STACKHOLDERS = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.47021 24.3143C2.47021 20.8143 7.13688 20.8143 9.47021 18.4809C10.6369 17.3143 7.13688 17.3143 7.13688 11.4809C7.13688 7.59245 8.69205 5.64761 11.8035 5.64761C14.915 5.64761 16.4702 7.59245 16.4702 11.4809C16.4702 17.3143 12.9702 17.3143 14.1369 18.4809C16.4702 20.8143 21.1369 20.8143 21.1369 24.3143"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M20.3589 13.0365L21.9498 14.6274C22.145 14.8227 22.4616 14.8227 22.6569 14.6274L26.5811 10.7032"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const SVG_INFO = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0736 0.647614C7.15749 0.647614 0.740234 7.06487 0.740234 14.9809C0.740234 22.897 7.15749 29.3143 15.0736 29.3143C22.9897 29.3143 29.4069 22.897 29.4069 14.9809C29.4069 7.06487 22.9897 0.647614 15.0736 0.647614ZM2.74023 14.9809C2.74023 8.16944 8.26206 2.64761 15.0736 2.64761C21.8851 2.64761 27.4069 8.16944 27.4069 14.9809C27.4069 21.7925 21.8851 27.3143 15.0736 27.3143C8.26206 27.3143 2.74023 21.7925 2.74023 14.9809ZM16.0736 14.9809C16.0736 14.4287 15.6259 13.9809 15.0736 13.9809C14.5213 13.9809 14.0736 14.4287 14.0736 14.9809V20.3143C14.0736 20.8666 14.5213 21.3143 15.0736 21.3143C15.6259 21.3143 16.0736 20.8666 16.0736 20.3143V14.9809ZM13.7402 10.9809C13.7402 10.2446 14.3372 9.64761 15.0736 9.64761C15.8099 9.64761 16.4069 10.2446 16.4069 10.9809C16.4069 11.7173 15.8099 12.3143 15.0736 12.3143C14.3372 12.3143 13.7402 11.7173 13.7402 10.9809Z"
      fill="currentColor"
    />
  </svg>
);

export const SVG_BRANCH_ICON = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5747 21.0815C13.5747 19.5627 14.8059 18.3315 16.3247 18.3315C17.8435 18.3315 19.0747 19.5627 19.0747 21.0815M13.5747 21.0815C13.5747 22.6003 14.8059 23.8315 16.3247 23.8315C17.8435 23.8315 19.0747 22.6003 19.0747 21.0815M13.5747 21.0815L1.19971 21.0815M19.0747 21.0815H23.1997M13.5747 4.58148C13.5747 3.0627 14.8059 1.83148 16.3247 1.83148C17.8435 1.83148 19.0747 3.0627 19.0747 4.58148M13.5747 4.58148C13.5747 6.10026 14.8059 7.33148 16.3247 7.33148C17.8435 7.33148 19.0747 6.10027 19.0747 4.58148M13.5747 4.58148L1.19971 4.58148M19.0747 4.58148L23.1997 4.58148M5.32471 12.8315C5.32471 11.3127 6.55592 10.0815 8.07471 10.0815C9.59349 10.0815 10.8247 11.3127 10.8247 12.8315M5.32471 12.8315C5.32471 14.3503 6.55592 15.5815 8.07471 15.5815C9.59349 15.5815 10.8247 14.3503 10.8247 12.8315M5.32471 12.8315L1.19971 12.8315M10.8247 12.8315L23.1997 12.8315"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SVG_LIST_ICON = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.57373 0.831482C0.745305 0.831482 0.0737305 1.50305 0.0737305 2.33148V21.3315C0.0737305 22.1599 0.745302 22.8315 1.57373 22.8315H20.5737C21.4022 22.8315 22.0737 22.1599 22.0737 21.3315V2.33148C22.0737 1.50305 21.4022 0.831482 20.5737 0.831482H1.57373ZM2.07373 20.8315V2.83148H20.0737V20.8315H2.07373ZM9.07373 5.83148C8.52145 5.83148 8.07373 6.2792 8.07373 6.83148C8.07373 7.38377 8.52145 7.83148 9.07373 7.83148H16.0737C16.626 7.83148 17.0737 7.38377 17.0737 6.83148C17.0737 6.2792 16.626 5.83148 16.0737 5.83148H9.07373ZM9.07373 10.8315C8.52145 10.8315 8.07373 11.2792 8.07373 11.8315C8.07373 12.3838 8.52145 12.8315 9.07373 12.8315H16.0737C16.626 12.8315 17.0737 12.3838 17.0737 11.8315C17.0737 11.2792 16.626 10.8315 16.0737 10.8315H9.07373ZM9.07373 15.8315C8.52145 15.8315 8.07373 16.2792 8.07373 16.8315C8.07373 17.3838 8.52145 17.8315 9.07373 17.8315H16.0737C16.626 17.8315 17.0737 17.3838 17.0737 16.8315C17.0737 16.2792 16.626 15.8315 16.0737 15.8315H9.07373ZM7.07373 6.83148C7.07373 7.38377 6.62602 7.83148 6.07373 7.83148C5.52145 7.83148 5.07373 7.38377 5.07373 6.83148C5.07373 6.2792 5.52145 5.83148 6.07373 5.83148C6.62602 5.83148 7.07373 6.2792 7.07373 6.83148ZM6.07373 12.8315C6.62602 12.8315 7.07373 12.3838 7.07373 11.8315C7.07373 11.2792 6.62602 10.8315 6.07373 10.8315C5.52145 10.8315 5.07373 11.2792 5.07373 11.8315C5.07373 12.3838 5.52145 12.8315 6.07373 12.8315ZM7.07373 16.8315C7.07373 17.3838 6.62602 17.8315 6.07373 17.8315C5.52145 17.8315 5.07373 17.3838 5.07373 16.8315C5.07373 16.2792 5.52145 15.8315 6.07373 15.8315C6.62602 15.8315 7.07373 16.2792 7.07373 16.8315Z"
      fill="currentColor"
    />
  </svg>
);

export const SVG_INTEGRATION = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.13672 1.83148H8.9145V9.60926H1.13672V1.83148Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M13.3589 1.83148H21.1367V9.60926H13.3589V1.83148Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M1.13672 14.0537H8.9145V21.8315H1.13672V14.0537Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M13.3589 14.0537H21.1367V21.8315H13.3589V14.0537Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);

export const SVG_GLOBE = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-globe-icon lucide-globe"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
    <path d="M2 12h20" />
  </svg>
);
